import {
  GuestJourneyStageGrid,
  GuestJourneyMemberTrendsResponse,
  GuestJourneySlidingCards,
  GuestJourneyVioTrend,
} from '../guest-journey-reports.types';
import { buildStageGrid } from './stage-grid.utils';

// Values arrive pre-formatted from the BE; the FE renders them verbatim.
export const slidingCardsFixture: GuestJourneySlidingCards = {
  membersWhoOrdered: {
    title: 'Members Who Ordered',
    value: '280,487',
  },
  sliders: {
    title: 'Sliders',
    value: '14,024',
    trend: { text: 'Trending Up', direction: 'UP', invertColor: true },
  },
  sliderRate: {
    title: 'Slider Rate',
    value: '5.0%',
    trend: { text: 'Trending Up', direction: 'UP', invertColor: true },
  },
  medianDaysFromLastOrder: {
    title: 'Median Days From Last Order',
    value: '2',
    trend: { text: 'Trending Up', direction: 'UP', invertColor: true },
  },
  projectedAnnualRevenue: {
    title: 'Projected Annual Revenue',
    value: '$12,034.12',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
};

// BE `GuestJourneyInsightDTO[]` — `GET v2/guest-journey/sliding/insights`.
export const slidersVioTrendsFixture: GuestJourneyVioTrend[] = [
  {
    text: 'More Core Regulars are beginning to slip into Slider status, suggesting a growing gap between visits rather than a drop in spend.',
    movement: { text: 'Moving Down', direction: 'DOWN_LEFT' },
  },
  {
    text: 'Value Explorers continue to make up the largest share of sliders, indicating early disengagement from lower-frequency guests.',
    movement: { text: 'Moving Down', direction: 'DOWN_LEFT' },
  },
  {
    text: 'A small rise in Indulgent Superfans entering Slider status may signal missed high-value retention opportunities despite stable average check.',
    movement: { text: 'Moving Up', direction: 'UP_RIGHT' },
  },
];

export const slidersGridFixture: GuestJourneyStageGrid = {
  countGrid: buildStageGrid([
    '1,087',
    '932',
    '785',
    '2,143',
    '2,612',
    '1,684',
    '1,876',
    '1,543',
    '1,362',
  ]),
  spendGrid: buildStageGrid([
    '$38,450',
    '$64,210',
    '$88,200',
    '$121,400',
    '$184,230',
    '$224,400',
    '$41,400',
    '$64,100',
    '$76,400',
  ]),
  visitsGrid: buildStageGrid([
    '2,120',
    '4,810',
    '8,120',
    '12,310',
    '24,400',
    '32,130',
    '8,420',
    '14,240',
    '24,230',
  ]),
};

export const slidersMemberTrendsFixture: GuestJourneyMemberTrendsResponse = {
  xlabels: [
    'Day 1',
    'Day 15',
    'Day 30',
    'Day 45',
    'Day 60',
    'Day 75',
    'Day 90',
  ],
  series: [
    {
      label: 'Indulgent Superfan',
      data: [510, 540, 580, 620, 660, 720, 785],
    },
    {
      label: 'Core Regular',
      data: [1840, 2010, 2200, 2310, 2440, 2520, 2612],
    },
    {
      label: 'Value Explorer',
      data: [1340, 1420, 1510, 1600, 1700, 1790, 1876],
    },
  ],
};
